import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import {DealerBlock} from "../Models/DealerBlock";
import { catchError } from 'rxjs/operators';

@Injectable()
export class DealerDashboardService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public getBlocks(gridData = new HttpParams(), scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/dealer-block/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public setPosition(position, id = null) {
    return this.http.put(environment.apiUrl + '/backoffice/dealer-block/' + id + '/change-position', position)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public delete(id, scope = 'backoffice') {
    return this.http.delete(environment.apiUrl + '/' + scope + '/dealer-block/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public reAdd(id, scope = 'backoffice') {
    return this.http.put(environment.apiUrl + '/' + scope + '/dealer-block/' + id + '/reAdd', {id: id})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getBlockItem(id, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/dealer-block/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  manageBlock(dealerBlock: DealerBlock, isEdit: boolean, id: number, scope = 'backoffice') {
    if (isEdit) {
      return this.http.put(environment.apiUrl + '/' + scope + '/dealer-block/' + id, dealerBlock)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/' + scope + '/dealer-block/', dealerBlock)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getOrderStatuses() {
    return this.http.get<any>(environment.apiUrl + '/backoffice/dealer-block/order-statuses')
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
